import {toast} from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

export function payloadAsFormData(formData, requestKey, payload) {
    for (let data in payload) {
        if (data === 'attachments' && payload['attachments']) {
            let attachmentLength = payload['attachments'].length;
            for (let i = 0; i < attachmentLength; i++) {
                if ((payload['attachments'][i]).hasOwnProperty('id')) {
                    continue;
                }
                if(requestKey === null) {
                    formData.append(`attachments[${i}]`, payload['attachments'][i]);
                } else {
                    formData.append(`${requestKey}[attachments][${i}]`, payload['attachments'][i]);
                }
            }
        } else if (data === 'image' && payload['image']) {
            formData.append(`${requestKey}[${data}]`, payload[data][0] ? payload[data][0] : '');
        } else if(requestKey === null) {
            formData.append(data, payload[data] != null ? payload[data] : '');
        } else {
            formData.append(`${requestKey}[${data}]`, payload[data] != null ? payload[data] : '');
        }
    }

    return formData;
}

export function asset(filePath) {
    return `${process.env.REACT_APP_BASE_URL}/storage/${filePath}`;
}

export function url(url) {
    return `${process.env.REACT_APP_BASE_URL}/api/v1/${url}`;
}

export const showSuccessNotification = (message) => {
    toast.success(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000, // Duration for the notification to automatically close
    });
};

export const translateToBanglaDigit = (number) => {
    if (!number) {
        return '';
    }

    const englishDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    const banglaDigits = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];

    // Convert the number to a string
    const numberString = number.toString();

    // Replace each English digit with its Bengali equivalent
    let translatedNumber = '';
    for (let i = 0; i < numberString.length; i++) {
        const digit = numberString[i];
        const index = englishDigits.indexOf(digit);
        if (index !== -1) {
            translatedNumber += banglaDigits[index];
        } else {
            translatedNumber += digit;
        }
    }

    return translatedNumber;
}

export const authToken = () => {
    return localStorage.getItem('accessToken');
}

export const authUser = () => {
    if (localStorage.getItem('user')) {
        return JSON.parse(localStorage.getItem('user'));
    } else {
        window.history.replaceState({}, '', `/login`);
    }
    return {};
}

export const axiosConfig = () => {
    return {
        headers: {
            authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        }
    }
}

export const formatDate = (date) => {
    if (!date) {
        return '';
    }

    let dateParts = date.split("-");
    let day = dateParts[2];
    let month = dateParts[1];
    let year = dateParts[0];

    return day + "-" + month + "-" + year;
}

export const isAdmin = () => {
    return authUser()?.role_id == 1;
}

export const isFocalPoint = () => {
    return authUser()?.role_id == 3;
}

export const formatTimeUTC = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return d.getUTCHours().toString().padStart(2,'0') + ':' +
        d.getUTCMinutes().toString().padStart(2,'0') + ':' +
        d.getUTCSeconds().toString().padStart(2,'0');
};
